export default __webpack_public_path__ + "static/media/Tabl_14.50b16154.svg";